import { render, staticRenderFns } from "./FulfillmentPerformanceDonutChartNew.vue?vue&type=template&id=2b864c7e"
import script from "./FulfillmentPerformanceDonutChartNew.vue?vue&type=script&lang=js"
export * from "./FulfillmentPerformanceDonutChartNew.vue?vue&type=script&lang=js"
import style0 from "./FulfillmentPerformanceDonutChartNew.vue?vue&type=style&index=0&id=2b864c7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports